import styled from 'styled-components';
import { Container } from 'styles';

export const StyledContainer = styled(Container).attrs({
  direction: 'column',
  flex: true,
})`
  ${props => props.theme.media.small`
    min-height: calc(100vh - 232px);
  `}
`;
